import type { DriveStep } from "driver.js";
import { ONBOARDING_IDS } from "../constants";

export const dashboardPeriodDataSteps: DriveStep[] = [
    {
        element: `#${ONBOARDING_IDS.DASHBOARD_HEADER}`,
        popover: {
            title: "Match Context",
            description:
                "This banner shows the two teams in the selected match, using your team's colours " +
                "to help you quickly orient between the Chosen (blue) and Opponent (red) datasets throughout the page.",
            side: "bottom",
            align: "center",
        },
    },
    {
        element: `#${ONBOARDING_IDS.PERIOD_DATA_NAV}`,
        popover: {
            title: "Period Selector",
            description:
                "Switch between individual periods (1st, 2nd, 3rd, overtime if available) to drill into a specific part of the game, " +
                "or choose All to see a combined summary table that spans every period at once.",
            side: "bottom",
            align: "start",
        },
    },
    {
        element: `#${ONBOARDING_IDS.PERIOD_DATA_CONTENT}`,
        popover: {
            title: "Period Statistics",
            description:
                "When a single period is selected, each row shows KPI scores broken down by stat category for both teams. " +
                "Selecting All switches to a summary table listing every period side-by-side, " +
                "making it easy to spot which period your team dominated or struggled in.",
            side: "top",
            align: "center",
        },
    },
];
